import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsByUTMTable from './StatisticsByUTMTable.js';
import {
    mainSelector,
    getHeaderName,
    getMetrics,
    getKeysMetric,
    getRowsCount
} from './StatisticsByUTMTable.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    headerName: getHeaderName,
    metrics: getMetrics,
    keysMetric: getKeysMetric,
    rowsCount: getRowsCount
});

const StatisticsByUTMTableComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.statistics.data.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByUTMTable);

export default StatisticsByUTMTableComponent;
